module.exports = __webpack_public_path__ + "img/no-image.859f0134.jpg";